import React from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { MdSearch } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'

import * as reducks from '../../../reducks'
import SearchDropdown from '../SearchDropdown/SearchDropdown'
import styles from './search.module.scss'

const Search = () => {
  const store = useSelector((state) => state.searchReducer)

  const dispatch = useDispatch()

  const {
    content: { visible }
  } = store

  const [search, setSearch] = React.useState('')

  const handleChange = (event) => {
    setSearch(event.target.value)

    if (event.target.value.length < 3) return null

    return dispatch(
      reducks.resources.search.actions.getSearch({
        search: event.target.value,
        title: event.target.value,
        per_page: 4
      })
    )
  }

  return (
    <div className={styles.containerInputSearch}>
      <MdSearch className={styles.iconSearch} color="#737373" />
      <input
        className={styles.search}
        type="text"
        placeholder="Pesquisar"
        value={search}
        onChange={handleChange}
      />
      <SearchDropdown visible={visible} searchText={search} />
    </div>
  )
}

export default Search
